import EndorsmentBadge from "../../../assets/images/training/icons/EndorsmentBadge.svg";
import { FiEdit, FiEye, FiMoreHorizontal, FiTrash2 } from "react-icons/fi";
import React, { useState } from "react"
import moment from "moment"
import { confirmAlert } from "react-confirm-alert";
import { setStatusForStudentInstructor } from "../../../store/slices/instructor-student.slice";
import { API_STATUS } from "../../../constants";
import useCustomToast from "../../../hooks/useCustomToast";
import EndorsementService from "../../../services/endorsement.service";
import { getEndorsements, getEndorsementsFromApi, setEndorsements } from "../../../store/slices/endorsement.slice";
import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { Link } from "react-router-dom";
function ListItem({ endorsement }: { endorsement: any }) {

  const dispatch = useAppDispatch()
  const endorsements = useAppSelector(getEndorsements)
  const [showMenu, setShowMenu] = useState(false);

  const customToast = useCustomToast()
  // Remove Endorsement
  const handleRemoveEndorsement = async (id: string): Promise<void> => {
    confirmAlert({
      title: 'Confirm',
      message: `Are you sure you want to remove?`,
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            dispatch(setStatusForStudentInstructor(API_STATUS.LOADING))
            const res: any = await EndorsementService.delete(id)
            if (res?.response?.status >= 400) {
              customToast(res?.response?.data?.message || 'Something went wrong', "error")
              return
            }
            customToast("Removed Successfully", "success")
            dispatch(setStatusForStudentInstructor(API_STATUS.SUCCEEDED))
            setTimeout(() => {
              dispatch(setEndorsements(endorsements.filter((item: any) => item._id !== id)))
            }, 500)
          },
        },
        {
          label: 'No',
          onClick: () => { },
        },
      ],
    })
  }
  return (
    <div className="list_item">
      {endorsement?.status === true ? <div className="badge">approved</div> : <div className="badge bg-warning">pending</div>}
      <div className="item_header d-flex justify-content-between align-items-start gap-3">
        <div className="left d-flex align-items-center gap-2 ">
          <img src={EndorsmentBadge} alt="" width={32.7} height={41} />
          <h6>{endorsement?.name}</h6>
        </div>
        <div className="right">
          <div
            className={`menu ${showMenu ? "active" : ""}`}
            onClick={() => setShowMenu(!showMenu)}>
            <span className="icon">
              <FiMoreHorizontal />
            </span>
            <ul className="options">
              <li>
                <Link to={`view/${endorsement?._id}`}>
                  <span>
                    <FiEye />
                  </span>
                  <span>View</span>
                </Link>
              </li>
              <li className="trash" onClick={() => handleRemoveEndorsement(endorsement?._id)}>
                <span>
                  <FiTrash2 />
                </span>
                <span>Delete</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col col-6">
          <div className="title">Student</div>
          <p className="content">{endorsement?.createdBy?.firstname} {endorsement?.createdBy?.lastname}</p>
        </div>
        <div className="col col-6">
          <div className="title">Instructor</div>
          <p className="content">{endorsement?.instructorId?.firstname} {endorsement?.instructorId?.lastname}</p>
        </div>
        <div className="col col-6">
          <div className="title">certificate #</div>
          <p className="content">{endorsement?.certificateNo}</p>
        </div>
        <div className="col col-6">
          <div className="title">Other</div>
          <p className="content">- - - - - -</p>
        </div>
        <div className="col col-6">
          <div className="title">Date of endorsement:</div>
          <p className="content">{moment(endorsement?.entryDate).format('DD MMMM, YYYY')}</p>
        </div>
        <div className="col col-6">
          <div className="title">Expiration</div>
          <p className="content">{moment(endorsement?.expiryDate).format('DD MMMM, YYYY')}</p>
        </div>
      </div>
    </div>
  );
}

export default ListItem;
